import React from "react";
import { TooltipMetadata } from "../../../../uiModel/tooltip/TooltipMetadata";
import { MenuButtonWithTooltipComponent } from "./MenuButtonWithTooltipComponent";
import { EnterFullscreenIcon, ExitFullscreenIcon } from "../../../icons";

interface Props {
  isFullscreen: boolean;
  onToggleFullscreen: () => void;
  onCancelTooltip: () => void;
  onRequestTooltip: (metadata: TooltipMetadata) => void;
}

export const DesktopFullscreenControlComponent: React.FC<Props> = ({
  isFullscreen,
  onToggleFullscreen,
  onCancelTooltip,
  onRequestTooltip,
}) => {
  const fullscreenIcon = isFullscreen ? <ExitFullscreenIcon /> : <EnterFullscreenIcon />;
  return (
    <MenuButtonWithTooltipComponent
      onClick={onToggleFullscreen}
      icon={fullscreenIcon}
      tooltipTarget="fullscreenControl"
      onCancelTooltip={onCancelTooltip}
      onRequestTooltip={onRequestTooltip}
    />
  );
};
